import { Tooltip } from "@mui/material"
import { InfoOutlined } from "@mui-symbols-material/w300"
import type { FC } from "react"

import type { Product } from "@/graphql/codegen/graphql"

interface InventoryProductDescriptionCellProps {
  product: Product
}

export const InventoryProductDescriptionCell: FC<InventoryProductDescriptionCellProps> = ({ product }) => {
  return (
    <div className='flex flex-col gap-y-1'>
      {product.companyProductDescription && (
        <div className='flex items-center gap-x-1'>
          <span className='whitespace-nowrap font-medium text-gray-900'>{product.companyProductDescription}</span>
          <Tooltip title='Akrochem Description' placement='right'>
            <InfoOutlined className='text-gray-600' fontSize='small' />
          </Tooltip>
        </div>
      )}
      {product.vendorDescription && (
        <div className='flex items-center gap-x-1'>
          <span className='whitespace-nowrap'>{product.vendorDescription}</span>
          <Tooltip title='Supplier Description' placement='right'>
            <InfoOutlined className='text-gray-600' fontSize='small' />
          </Tooltip>
        </div>
      )}
    </div>
  )
}
